/* Elyfit — fiche produit : choix des options, quantité, galerie */
(function () {
  function init(racine) {
    racine.querySelectorAll('[data-ely-fiche]').forEach(function (fiche) {
      if (fiche.dataset.elyPret) return;
      fiche.dataset.elyPret = '1';

      var variantes = JSON.parse(fiche.querySelector('[data-variantes]').textContent);
      var form = fiche.querySelector('[data-ely-form]');
      var champId = fiche.querySelector('[data-variante]');
      var prix = fiche.querySelector('[data-prix]');
      var prixBarre = fiche.querySelector('[data-prix-barre]');
      var bouton = fiche.querySelector('[data-ajouter]');
      var format = new Intl.NumberFormat(document.documentElement.lang || 'fr', {
        style: 'currency', currency: fiche.dataset.devise || 'EUR'
      });

      function montrerMedia(id) {
        if (!id) return;
        var cible = fiche.querySelector('.ely-fiche__slide[data-media-id="' + id + '"]');
        if (!cible) return;
        fiche.querySelectorAll('.ely-fiche__slide').forEach(function (s) { s.hidden = s !== cible; });
        fiche.querySelectorAll('.ely-fiche__vignette').forEach(function (b) {
          b.setAttribute('aria-current', b.dataset.cible === String(id));
        });
      }

      function majVariante() {
        var choix = [];
        form.querySelectorAll('input[type="radio"]:checked').forEach(function (r) { choix[+r.dataset.index] = r.value; });
        form.querySelectorAll('[data-option-valeur]').forEach(function (el) { el.textContent = choix[+el.dataset.optionValeur] || ''; });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === choix[i]; }); });
        if (!v) {
          bouton.disabled = true;
          bouton.textContent = 'Indisponible';
          return;
        }
        champId.value = v.id;
        prix.textContent = format.format(v.price / 100);
        if (prixBarre) {
          prixBarre.hidden = !(v.compare_at_price > v.price);
          if (v.compare_at_price) prixBarre.textContent = format.format(v.compare_at_price / 100);
        }
        bouton.disabled = !v.available;
        bouton.textContent = v.available ? bouton.dataset.libelle : 'Épuisé';
        if (v.featured_media) montrerMedia(v.featured_media.id);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      form.querySelectorAll('input[type="radio"]').forEach(function (r) { r.addEventListener('change', majVariante); });

      var quantite = form.querySelector('input[name="quantity"]');
      form.querySelectorAll('[data-quantite]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Math.max(1, (parseInt(quantite.value, 10) || 1) + parseInt(b.dataset.quantite, 10));
          quantite.value = n;
        });
      });
      quantite.addEventListener('change', function () {
        quantite.value = Math.max(1, parseInt(quantite.value, 10) || 1);
      });

      fiche.querySelectorAll('.ely-fiche__vignette').forEach(function (b) {
        b.addEventListener('click', function () { montrerMedia(b.dataset.cible); });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
